import React from 'react';
import CustomTabPanel from 'components/Shared/CustomTabPanel';
import CustomTabs from 'components/Shared/CustomTabs';
import RowsSkeleton from 'components/Shared/Skeleton/RowsSkeleton';
import { useSearchParams } from 'react-router-dom';
import NoteTab from '../../Note/Notetab';
import { useGetNotesBySourceQuery } from 'store/services/noteApi';
import { useDeconsolidationDetailContext } from "contexts/DeconsolidationDetailContext";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";
import DocumentsTab from "../../Document/DocumentTab";
import DeconsolidationShipmentList from "./DeconsolidationShipmentList";

const DeconsilidationDetailTab = () => {
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('tab') || 'note';
  const { deconsolidationDetail } = useDeconsolidationDetailContext();


  // Fetch notes to get the count for the badge
  const { data: notes } = useGetNotesBySourceQuery(
    {
      source: 'Deconsolidation',
      sourceRef: deconsolidationDetail?._id,
    },
    { skip: !deconsolidationDetail?._id }
  );

  // Fetch documents to get the count for the badge
  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: 'Deconsolidation', sourceRef: deconsolidationDetail?._id, }, { skip: !deconsolidationDetail?._id }
  );

  const tabs = [
    {
      label: 'Note',
      value: 'note',
      badgeCount: notes?.length || 0,
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },
      { label: "Shipment", value: "shipment", badgeCount: deconsolidationDetail?.shipmentId?.length },

  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {deconsolidationDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="note">
            <NoteTab source="Deconsolidation" sourceRef={deconsolidationDetail._id} />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab source="Deconsolidation" sourceRef={deconsolidationDetail._id} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="shipment">
                    <DeconsolidationShipmentList/>
                    </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
}

export default DeconsilidationDetailTab